// src/components/pages/sports/Partials/HighlightSports.jsx
import React, { useEffect } from "react";

import { Link } from "react-router-dom";

const HighlightSports = ({ highlightsSection }) => {
  // fallback static list (keeps previous behaviour if API not passed)
  const fallback = [
    {
      slug: "studentsports",
      title: "STUDENTS",
      image: "https://caredemo.care.edu.in/assets/images/sportsimg1.webp",
      overlay: "overlay-blue",
    },
    {
      slug: "staffsports",
      title: "STAFFS",
      image: "https://caredemo.care.edu.in/assets/images/sportsimg1.webp",
      overlay: "overlay-grey",
    },
    {
      slug: "tournamentsports",
      title: "TOURNAMENTS",
      image: "https://caredemo.care.edu.in/assets/images/sportsimg1.webp",
      overlay: "overlay-blue",
    },
  ];

  // build highlights array from highlightsSection (API shape)
  const highlights =
    highlightsSection &&
    highlightsSection.highlights &&
    highlightsSection.highlights.length > 0
      ? highlightsSection.highlights.map((h) => ({
          slug:
            h.slug ||
            h.slug?.toString?.() ||
            (h.title && h.title.toLowerCase().replace(/\s+/g, "")) ||
            "",
          title: h.title || h.text || "Highlight",
          overlay: h.overlay || h.overlay_class || "overlay-blue",
          // Prefer new_image if provided else fallback to image_url. Prepend base API url.
          image:
            h.new_image && h.new_image[0]
              ? `${process.env.REACT_APP_API_URL}${h.new_image[0]}`
              : h.image_url
                ? `${process.env.REACT_APP_API_URL}/public${h.image_url}`
                : h.image || "",
        }))
      : fallback;

  return (
    <>
      <div className="sec-title text-center">
        <h2>
          {(highlightsSection && highlightsSection.heading) ||
            "SPORTS HIGHLIGHTS"}
        </h2>
      </div>

      <section className="gallery-sports d-flex justify-content-center align-items-center">
        <div className="container">
          <div className="row d-flex justify-content-center align-items-center">
            {highlights.map((item, index) => (
              <div className="col-md-3 col-12 mb-3" key={index}>
                <Link
                  to={`/sports/highlights/${item.slug}`} // route assumed like /studentsports
                  className={`image-grid-link ${item.overlay === "overlay-grey" ? "grayscale" : ""}`}
                  style={{
                    backgroundImage: `url('${item.image || "/assets/images/default-banner.webp"}')`,
                  }}
                >
                  <div className={`overlay ${item.overlay}`}>
                    <h5>{item.title}</h5>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default HighlightSports;
